import { Box, BoxProps, Container } from '@chakra-ui/react';
import React from 'react';

export const CONTAINER_MAX_WIDTH = '8xl';

export function PageContent({
  maxWidth = CONTAINER_MAX_WIDTH,
  backgroundColor,
  ...rest
}: BoxProps) {
  return (
    <Container
      position="relative"
      zIndex="base"
      paddingTop={0}
      paddingBottom={0}
      maxW="full"
      backgroundColor={backgroundColor}
    >
      <Box marginX="auto" maxWidth={maxWidth} paddingX={0} {...rest} />
    </Container>
  );
}
